export const poolId = 'eu-west-1_CO4L2kq2q';
export const poolClientId = '2g8fi949ccgg8kdtehe8qkt2dl';
